<template>
    <div class="body-panel">
        <div class="body-panel-content">
            <div class="body-panel-content-start flex">
                <div class="login-page-bg">
                </div>
                <div class="login-page">
                    <div class="login-logo" v-if="info.StartImage != null">
                        <img class="login-logo-img" :src="info.StartImage" />
                    </div>
                    <div class="login">
                        <div class="form-header">
                            Активация аккаунта
                        </div>
                        <template v-if="result != null">
                            <div class="auth-content-block">
                                <div class="form-field">
                                    <b>Логин:</b> {{result.login}}
                                </div>
                                <div class="form-field">
                                    <input name="UserPassword" type="password" placeholder="Пароль"
                                           v-validate="'required'"
                                           v-model="password"
                                           data-vv-as='"Пароль"'
                                           @input="onNewPasswordChange"
                                           :class="['input-text', {'input-error': errors.has('password')}]">
                                    <span class="field-validation-valid">{{ errors.first('password') }}{{passwordError}}</span>
                                </div>
                                <div class="form-field">
                                    <input name="PasswordConfirm" type="password" placeholder="Повторите пароль"
                                           v-validate="{required: true, confirmed:password}"
                                           v-model="passwordConfirm"
                                           data-vv-as='"Повторите пароль"'
                                           :class="['input-text', {'input-error': errors.has('passwordConfirm')}]">
                                    <span class="field-validation-valid">{{ errors.first('passwordConfirm') }}</span>
                                </div>
                            </div>
                            <div class="form-actions">
                                <div class="form-btns">
                                    <button type="submit" class="btn btn-primary" @click="setPassword">
                                        Установить пароль
                                    </button>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>

        <vue-headful title="Активация аккаунта" />
    </div>
</template>

<script>
  import UI from '../helpers/ui-helpers'
  import BackendApi from '../backendApi'

  let backendApi = new BackendApi();

  export default {
      name: "activation",

      props: ['info'],

      data(){
          return{
              result: null,
              password: null,
              passwordConfirm: null,
              passwordError: null
          }
      },

      methods:{
          onNewPasswordChange() {
              this.passwordError = null;

              if (!this.password || !this.password.trim()) {
                  //this.password.Error = null;
              } else {
                  let newpass = this.password;

                  if (newpass.length < 6) {
                      this.passwordError = 'Введите минимум 6 символов';
                  }
                  else if (!/(?=.*\d).*\D.*/ig.test(newpass)) {
                      this.passwordError = 'Обязательно наличие и букв и цифр';
                  }
                  else if (!/(?=.*[A-ZА-Я]).*[a-zа-я].*/g.test(newpass)) {
                      this.passwordError = 'Обязательно наличие заглавной и прописной буквы';
                  }
              }
          },

          setPassword(){
              let vm = this;
              this.$validator.validate().then(result => {
                  if (result) {

                      let hash = vm.$route.params.hash;
                      backendApi.userActivation(hash, vm.password).then(function (response) {
                          console.info('response', response)
                          if (response.hasError) {
                              UI.toastr.error('Ошибка при смене пароля');
                          }else {
                              UI.toastr.success('Пароль успешно задан');
                              vm.$router.push('/login');
                          }
                      });

                  }
              });
          }
      },

      mounted() {
          let vm = this;

          let hash = vm.$route.params.hash;
          if(!hash){
              vm.$router.push('/login');
          }

          backendApi.userActivationInfo(hash).then(function (response) {
              if (response.hasError) {
                  if(response.status === 1404){
                      // неверный hash
                      console.info('неверный hash');
                      vm.$router.push('/login');
                  }
                  else{
                      UI.toastr.error('Ошибка при загрузке страницы');
                  }
              }
              else {
                  if (response.data != null) {
                      vm.result = response.data;
                  }
              }
          });
      }

  }
</script>

<style scoped="">

</style>


// WEBPACK FOOTER //
// Content/src/views/Activation.vue